import './logic.css'
import View from './view.js'

export default function Logic(props) {
  return <View {...props} />
}
